// src/components/modals/ForgetPasswordModal.js
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { forgetPassword } from "../../../services/TenantsService";
import { toast } from "react-toastify";

const ForgetPasswordModal = ({ show, onClose, userData }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    if (!password.trim()) newErrors.password = "Password is required";
    if (!confirmPassword.trim())
      newErrors.confirmPassword = "Confirm Password is required";

    if (password && confirmPassword && password !== confirmPassword)
      newErrors.confirmPassword = "Passwords do not match";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    if (!userData?.id) {
      toast.success("User ID not found !", {
        position: "top-right",
        autoClose: 1000,
      });
      return;
    }

    try {
      setLoading(true);

      const payload = {
        id: userData.id,
        password: password,
      };

      await forgetPassword(payload);

      toast.success("Password changed successfully", {
        position: "top-right",
        autoClose: 1000,
      });
      setPassword("");
      setConfirmPassword("");

      onClose();
    } catch (err) {
      console.error("Error changing password:", err);
      toast.error("Failed to change password", {
        position: "top-right",
        autoClose: 1000,
      });
    } finally {
      setLoading(false);
    }
  };

  // Optional: reset fields when modal is closed
  React.useEffect(() => {
    if (!show) {
      setPassword("");
      setConfirmPassword("");
      setShowPassword(false);
      setShowConfirmPassword(false);
    }
  }, [show]);

  return (
    <Modal className="fade" show={show} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title>Change Password</Modal.Title>
        <Button variant="" className="btn-close" onClick={onClose} />
      </Modal.Header>

      <Modal.Body>
        <div className="row">
          {/* Password */}
          <div className="col-sm-12">
            <div className="form-group">
              <label className="form-label" htmlFor="password">
                Password <span className="text-danger">*</span>
              </label>
              <div className="input-group pass-group">
                <input
                  placeholder="Password"
                  id="password"
                  type={showPassword ? "text" : "password"}
                  className={`form-control pass-input ${
                    showPassword ? "active" : ""
                  }`}
                  name="password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setErrors((prev) => ({ ...prev, password: "" }));
                  }}
                  style={
                    errors.password
                      ? {
                          borderColor: "#dc3545",
                          borderRight: "none",
                        }
                      : {}
                  }
                />
                <span
                  className={`input-group-text pass-handle ${
                    showPassword ? "active" : ""
                  }`}
                  style={
                    errors.password
                      ? {
                          borderColor: "#dc3545",
                          borderLeft: "none",
                        }
                      : {}
                  }
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  <i className="fa fa-eye-slash" />
                  <i className="fa fa-eye" />
                </span>
              </div>
              {errors.password && (
                <small className="text-danger m-lg-2">{errors.password}</small>
              )}
            </div>
          </div>

          {/* Confirm Password */}
          <div className="col-sm-12">
            <div className="form-group">
              <label className="form-label" htmlFor="confirm_password">
                Confirm Password <span className="text-danger">*</span>
              </label>
              <div className="input-group pass-group">
                <input
                  placeholder="Confirm Password"
                  id="confirm_password"
                  type={showConfirmPassword ? "text" : "password"}
                  className="form-control pass-input"
                  required
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    setErrors((prev) => ({ ...prev, confirmPassword: "" }));
                  }}
                  style={
                    errors.confirmPassword
                      ? {
                          borderColor: "#dc3545",
                          borderRight: "none",
                        }
                      : {}
                  }
                />
                <span
                  className={`input-group-text pass-handle ${
                    showConfirmPassword ? "active" : ""
                  }`}
                  onClick={() => setShowConfirmPassword((prev) => !prev)}
                  style={
                    errors.confirmPassword
                      ? {
                          borderColor: "#dc3545",
                          borderLeft: "none",
                        }
                      : {}
                  }
                >
                  <i className="fa fa-eye-slash"></i>
                  <i className="fa fa-eye"></i>
                </span>
              </div>
              {errors.confirmPassword && (
                <small className="text-danger m-lg-2">
                  {errors.confirmPassword}
                </small>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="danger light" onClick={onClose} disabled={loading}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? "Saving..." : "Save changes"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ForgetPasswordModal;
